import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { sanitizeHtml } from '../lib/sanitize';
import SEO from '../components/SEO';

export default function DynamicCmsPage() {
    const { slug } = useParams();
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        setLoading(true);
        setNotFound(false);
        api.get(`/pages/${slug}`)
            .then((r) => setPage(r.data))
            .catch(() => setNotFound(true))
            .finally(() => setLoading(false));
    }, [slug]);

    if (loading) return <div className="py-20 text-center eyebrow" style={{ color: 'var(--ink-muted)' }}>Loading...</div>;

    if (notFound) {
        return (
            <>
                <SEO title="Page Not Found" noIndex description="The page you are looking for does not exist." />
                <div className="py-24 text-center">
                    <p className="eyebrow" style={{ color: 'var(--brand-burgundy)' }}>404</p>
                    <h1 className="font-serif text-5xl md:text-6xl mt-2" style={{ color: 'var(--brand-burgundy)' }}>Page Not Found</h1>
                    <hr className="divider-burgundy mt-5 mx-auto" />
                    <p className="mt-6 text-sm" style={{ color: 'var(--ink-muted)' }}>The page you are looking for does not exist.</p>
                </div>
            </>
        );
    }

    return (
        <>
            <SEO
                title={page.meta_title || page.title}
                description={page.meta_description}
                image={page.meta_image}
                canonical={`/${page.slug}`}
                type="article"
            />
            <div className="max-w-[820px] mx-auto px-4 sm:px-6 lg:px-10 py-12 lg:py-16" data-testid={`cms-page-${slug}`}>
                <div className="text-center mb-10">
                    <p className="eyebrow" style={{ color: 'var(--brand-burgundy)' }}>by anfal</p>
                    <h1 className="font-serif text-5xl md:text-6xl mt-2 shine-text" data-testid="cms-page-title">{page.title}</h1>
                    <hr className="divider-burgundy mt-5 mx-auto" />
                </div>
                <article className="prose-luxury" data-testid="cms-page-content" dangerouslySetInnerHTML={{ __html: sanitizeHtml(page.body) }} />
            </div>
        </>
    );
}
